export default __webpack_public_path__ + "static/media/formulaDaVitoriaLogo.35af6aea.png";